module.exports = __webpack_public_path__ + "img/www.martindale.com.405a6992.png";